function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.594 1.406a4.8 4.8 0 00-6.788 0L7.128 4.084a6.206 6.206 0 012.602.282l1.518-1.518A2.74 2.74 0 0113.2 2.04c.737 0 1.43.287 1.952.808A2.74 2.74 0 0115.96 4.8c0 .736-.287 1.43-.808 1.95l-2.97 2.97a2.742 2.742 0 01-1.951.809 2.74 2.74 0 01-1.952-.809 2.728 2.728 0 01-.588-.868c-.338.02-.655.16-.897.401l-.79.792a4.8 4.8 0 007.621 1.119l2.97-2.971a4.8 4.8 0 000-6.787z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.262 13.949c-.68 0-1.344-.11-1.983-.327L6.751 15.15a2.738 2.738 0 01-1.95.809 2.74 2.74 0 01-1.952-.809A2.738 2.738 0 012.04 13.2c0-.737.287-1.43.809-1.952l2.97-2.97a2.741 2.741 0 011.95-.806 2.765 2.765 0 012.541 1.676c.34-.018.657-.16.898-.4l.79-.792a4.8 4.8 0 00-7.622-1.12l-2.97 2.971a4.798 4.798 0 000 6.788 4.799 4.799 0 006.788 0l2.674-2.674c-.2.019-.4.03-.604.03l-.002-.001z"
});

var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/link.1d86d016.svg";
export { SvgLink as ReactComponent };